<template>
  <custom-dialog
    width="1450px"
    class="route-history-dialog"
    :visible="visible"
    :append-to-body="true"
    v-on="$listeners"
    :title="model.title"
  >
    <div class="dialog-body">
      <div class="search-hd">
        <el-form
          :inline="true"
          @submit.native.prevent
        >
          <el-form-item style="float: right">
            <custom-date-picker
              style="width: 100%"
              v-model="formSearch.operateTime"
              type="daterange"
              align="right"
              value-format="YYYY-MM-DD HH:mm:ss"
              @change="onPageChange({page:1})"
            ></custom-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <div class="table-bd">
        <custom-table
          tableCode="route_history_note"
          ref="table"
          @sort="sortChange"
          @filter="filterChange"
          height="400px"
          :data="tableList"
          :slots="['thumb', 'action']"
        >
          <template v-slot:thumb="scope">
            <div class="thumb-content">
              <el-image
                v-if="scope.row.thumb"
                fit="contain"
                class="img"
                :src="scope.row.thumb"
                :preview-src-list="[scope.row.thumb]"
              ></el-image>
            </div>
          </template>
          <template v-slot:action="scope">
            <el-button
              v-if="isDelStatus(scope.row) && funcView.route_recover"
              type="text"
              size="mini"
              @click="onRecover(scope.row)"
            >{{funcView.route_recover}}</el-button>
            <el-button
              type="text"
              size="mini"
              v-if="isTranslate(scope.row) && scope.row.oldHlcSlotId && funcView.route_check_up"
              @click="onCheckSource(scope.row)"
            >{{funcView.route_check_up}}</el-button>
          </template>
        </custom-table>
      </div>
      <div class="table-page">
        <custom-page
          :total="totalRows"
          :page="formSearch.pageNum"
          :size="formSearch.pageSize"
          @change="onPageChange"
        ></custom-page>
      </div>
    </div>
    <div
      class="dialog-footer"
      slot="footer"
    >
      <el-button
        @click="closeDialog"
        type="primary"
      >{{$t('Common.com_confirm')}}</el-button>
    </div>
    <check-source-dialog
      v-if="checkSourceVisible"
      @close="checkSourceVisible = false"
      :model="checkSourceModel"
    ></check-source-dialog>
  </custom-dialog>
</template>

<script>
import dialogMixins from '@/mixins/dialog_mixins';
import apis from '@/utils/apis';
import checkSourceDialog from './check_source_dialog.vue';

export default {
  name: '',
  mixins: [dialogMixins],
  components: {
    checkSourceDialog
  },
  props: {
  },
  data() {
    return {
      formSearch: {
        operateTime: '',
        pageSize: 50,
        pageNum: 1,
      },
      tableList: [],
      totalRows: 0,

      checkSourceVisible: false,
      checkSourceModel: {},
    };
  },
  computed: {
  },
  watch: {
  },
  filters: {
  },
  directives: {
  },
  methods: {
    onCheckSource(row) {
      const { hlcCode, locationName, siteName, slotCode } = row;
      const str = [hlcCode, locationName, siteName, slotCode].filter(val => val).join('/');
      const tips = this.$t('dms_route_history_dialog.cha_kan_lai_yuano', [str]);
      this.checkSourceModel = {
        title: tips,
        data: row
      };

      this.checkSourceVisible = true;
    },
    async onRecover(row) {
      const { hlcCode, siteName, slotCode, mapName } = row;
      const slotCodeName = this.dicMap.sbr_slot[slotCode];
      const subStr = [hlcCode, siteName, slotCodeName].filter(val => val).join('/');
      const tips = this.$t('dms_route_history_dialog.nqdyhflxoom', [subStr,mapName]);
      await this.$showConfirm(tips);
      const reqUrl = `${apis.hlcSlotRecover}/${row.hlcSlotHistId}`;
      await this.$postJSON(reqUrl);
      this.$message({
        message: this.$t('Common.com_handle_success'),
        type: 'success'
      });
      this.getTableList();
    },
    // 判断是否为转移数据
    isTranslate(row) {
      if (this.dicMap.hlc_slot_state) {
        return `${this.dicMap.hlc_slot_state.transfer}` === `${row.hlcSlotState}`;
      }
      return false;
    },
    isDelStatus(row) {
      if (this.dicMap.hlc_slot_state) {
        return `${this.dicMap.hlc_slot_state.remove}` === `${row.hlcSlotState}`;
      }
      return false;
    },
    getTableList() {
      const url = apis.hlcSlotHistoryPage;
      const { hlcCode, productCode, siteId } = this.model.data;
      const reqData = {
        hlcCode,
        productCode,
        siteId,
        ...this.formSearch
      };
      this.$getJSON(url, reqData).then((res) => {
        const list = res.data.records;
        list.forEach((item) => {
          const bizType = 'i';
          const bizId = item.mapId;
          this.$getFileList({
            bizId,
            bizType
          }).then((fileList) => {
            const urlList = fileList.map(i => i.url);
            if (urlList.length) {
              this.$set(item, 'thumb', urlList[0]);
            }
          });
        });
        this.tableList = list;
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    closeDialog() {
      this.visible = false;
    }
  },
  created() {
  },
  mounted() {
    this.getFuncView();
    this.getDicMap('sbr_slot,hlc_slot_state', () => {
      this.getTableList();
    });
  },
};
</script>

<style lang="scss">
.route-history-dialog {
  .thumb-content {
    width: 80px;
    height: 80px;
  }
}
</style>
